import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowOutTopLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareArrowOutTopLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H11V4.5H5.56066L11.3107 10.25L10.25 11.3107L4.5 5.56066V11H3V3ZM13 6H22V22H6V13H7.5V20.5H20.5V7.5H13V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowOutTopLeft;
